import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  fetchAllDevicesFailed,
  fetchAllDevicesRequested,
  fetchAllDevicesSucceeded,
  fetchRealtimeDatasFailed,
  fetchRealtimeDatasRequested,
  fetchRealtimeDatasSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* fetchAllDevicesRequest() {
  yield put(fetchAllDevicesRequested());

  try {
    const { items, included } = yield call(request, api.getAllDevices);

    const action = fetchAllDevicesSucceeded(items, included);
    yield put(action);
    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchAllDevicesFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchRealtimeDatasRequest() {
  yield put(fetchRealtimeDatasRequested());

  try {
    const { items } = yield call(request, api.getRealtimeDatas);

    const action = fetchRealtimeDatasSucceeded(items);
    yield put(action);
    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchRealtimeDatasFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
